import { trackEvent } from '../segment';

interface Page {
    spineItemPageIndex: number;
    spineItemPageCount: number;
    idref: string;
    spineItemIndex: number;
}

interface PaginationInfo {
    canGoLeft: () => boolean;
    canGoRight: () => boolean;
    canGoPrev: () => boolean;
    canGoNext: () => boolean;
    isRightToLeft: boolean;
    isFixedLayout: boolean;
    spineItemCount: number;
    openPages: Page[];
}

export const nextPage = (window: Window) =>
    window[0]?.READIUM.reader.openPageNext();

export const prevPage = (window: Window) =>
    window[0]?.READIUM.reader.openPagePrev();

export const goToPage = (window: Window, index: number) => {
    window[0]?.READIUM?.reader?.openPageIndex(index);
};

export const getPaginationInfo = (window: Window) =>
    window[0]?.READIUM?.reader?.getPaginationInfo() as PaginationInfo;

//callin g directly from window
export const handlePageChange = (
    window: Window,
    eventName?: string,
    currentPageNum?: string
) => window[0]?.handlePageChange(eventName, currentPageNum);

export const checkIframesWithDelay = (window: Window) =>
    window[0].checkIframesWithDelay();

export const checkIframes = (window: Window) => {
    window[0]?.checkIframes();
};
export const resourceConfigData = (window: Window, newData: any) => {
    if (newData !== undefined && window[0] !== undefined) {
        window[0].resourceConfigData = newData?.resourceConfig;
    }
};
export const highlightTextInIframe = (window: Window, searchText: string) => {
    window[0]?.highlightTextInIframe(searchText);
};
export const captureSelection = (window: Window, capture: string) => {
    window[0]?.captureSelection(capture);
};
export const getCfiOnClick = (window: Window, capture: string) => {
    window[0]?.getCfiOnClick(capture);
};
export const bookMarkCurrentPage = (window: Window) =>
    window[0]?.READIUM.reader.bookmarkCurrentPage();
export const goTOPageHref = (window: Window, href: string) =>
    window[0]?.READIUM.reader.openContentUrl(href); //readium function build in

export const getCurrentPage = (window: Window) =>
    getPaginationInfo(window)?.openPages[0]?.idref;
export const addNoteIcon = (window: Window, notesData: any) => {
    window[0]?.addNoteIcon(notesData);
};

export const highlightText = (
    window: Window,
    cfi: any,
    highlightColor: string,
    id: number
) => window[0]?.applyHighlight(cfi, highlightColor, id);

export const removeHighlightText = (window: Window, id: number) =>
    window[0]?.removeHighlightById(id);
export const zoomIn = (window: Window) => {
    //old event
    trackEvent('epub_viewer_view_zoomin_clicked', {});
    trackEvent('click_zoom_in', {});
    window[0]?.READIUM.reader.setZoom({
        style: 'user',
        scale:
            window[0]?.READIUM.reader.getViewScale() / 100 <= 2.0
                ? window[0]?.READIUM.reader.getViewScale() / 100 + 0.25
                : window[0]?.READIUM.reader.getViewScale() / 100,
    });

    window[0]?.toggleDrag();
};
export const removeNoteIcon = (window: Window, noteId: any) => {
    window[0]?.removeNoteIcon(noteId);
};

export const zoomOut = (window: Window) => {
    trackEvent('click_zoom_out', {});
    window[0]?.READIUM.reader.setZoom({
        style: 'user',
        scale:
            window[0]?.READIUM.reader.getViewScale() / 100 >= 0.7
                ? window[0]?.READIUM.reader.getViewScale() / 100 - 0.25
                : window[0]?.READIUM.reader.getViewScale() / 100,
    });

    window[0]?.toggleDrag();
};

export const backToNormal = (window: Window) => {
    trackEvent('click_back_to_normal_view', {});
    window[0]?.READIUM.reader.setZoom({
        style: 'original',
    });

    window[0]?.resetDrag();
};
